import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../components-css/popup.scss';
import crossIcon from '../assets/svgs/cross.svg';
import ArrowIcon from '../assets/svgs/Group 3.svg';
import downloadImg from '../assets/svgs/download.svg';
import GradientArrowIcon from '../assets/svgs/Group 3 (5).svg';
import { BASE_URL } from '../config';
import axios from 'axios';

const Popup = ({ jobTitle, onClose, id }) => {
    const [isHovered, setIsHovered] = useState(false);
    const [errors, setErrors] = useState({});
    
    const [formData, setFormData] = useState({
        job_id: id || "",
        name: "",
        email: "",
        phone: "",
        address: "",
        experience_in_years: "",
        current_employer: "",
        notice_period: "",
        current_salary: "",
        expected_salary: "",
        link: "",
        resume: null
    });
    const [resumeName, setResumeName] = useState(""); // Stores file name for display

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log("name",name)
        console.log("value",value)
        setFormData(prevState => ({ ...prevState, [name]: value }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData(prevState => ({ ...prevState, resume: file }));
            setResumeName(file.name); // Show file name after selection
        }
    };

    const jobApply = async (e) => {
        e.preventDefault();

        try {
            let payload = new FormData();
            Object.keys(formData).forEach(key => {
                payload.append(key, formData[key]);
            });

            let response = await axios.post(`${BASE_URL}/apply-job`, payload, {
                headers: { "Content-Type": "multipart/form-data" }
            });

            toast.success("Application submitted successfully!", { autoClose: 3000 });
            
            // Optional: Close popup after successful submission
            setTimeout(() => {
                onClose();
            }, 3000);
        } catch (error) {
            toast.dismiss();
            if (error.response?.data?.errors) {
                setErrors(error.response.data.errors);
            } else {
                toast.error(error?.response?.data?.message || "Failed to send your message. Please try again.", { toastId: "error-msg" });
            }
            toast.error(error.response.data.message);

        }
    };

    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <div className="cross-icon">
                    <img onClick={onClose} src={crossIcon} alt="Close" />
                </div>
                <p className='apply'>APPLY FOR JOB</p>
                <h2>{jobTitle}</h2>
                <p>at OmkaTech</p>
                <form onSubmit={jobApply}>
                    <div className='form-input'>
                        <input type="text" name="name" placeholder='Your name*' onChange={handleChange} />
                        {errors.name && <div className="error-text">{errors.name[0]}</div>}
                    </div>
                    <div className='form-input'>
                        <input type="email" name="email" placeholder='Email address*' onChange={handleChange} />
                        {errors.email && <div className="error-text">{errors.email[0]}</div>}
                    </div>
                    <div className='form-input'>
                        <input type="number" name="phone" placeholder='Phone*' onChange={handleChange} />
                        {errors.phone && <div className="error-text">{errors.phone[0]}</div>}
                    </div>
                    <div className='form-input'>
                        <input type="text" name="address" placeholder='Address' onChange={handleChange} />
                        {errors.address && <div className="error-text">{errors.address[0]}</div>}
                    </div>
                    <div className='form-input'>
                        <input type="number" name="experience_in_years" placeholder='Experience in Years' onChange={handleChange} />
                        {errors.experience_in_years && <div className="error-text">{errors.experience_in_years[0]}</div>}
                    </div>
                    <div className='form-input'>
                        <input type="text" name="current_employer" placeholder='Current Employer' onChange={handleChange} />
                        {errors.current_employer && <div className="error-text">{errors.current_employer[0]}</div>}
                    </div>
                    <div className='form-input'>
                        <input type="text" name="notice_period" placeholder='Notice Period*' onChange={handleChange} />
                        {errors.notice_period && <div className="error-text">{errors.notice_period[0]}</div>}
                    </div>
                    <div className='form-input'>
                        <input type="number" name="current_salary" placeholder='Current Salary (CTC)*' onChange={handleChange} />
                        {errors.current_salary && <div className="error-text">{errors.current_salary[0]}</div>}
                    </div>
                    <div className='form-input'>
                        <input type="number" name="expected_salary" placeholder='Expected Salary (ECTC)*' onChange={handleChange} />
                        {errors.expected_salary && <div className="error-text">{errors.expected_salary[0]}</div>}
                    </div>
                    <div className='form-input'>
                        <input type="text" name="link" placeholder='LinkedIn Profile or Portfolio Link*' onChange={handleChange} />
                        {errors.link && <div className="error-text">{errors.link[0]}</div>}

                    </div>
                    
                    <input type="file" id="fileInput" className="file-input" onChange={handleFileChange} />
                    <label htmlFor="fileInput" className="file-label">
                        <div className="file-type-design">
                            <img src={downloadImg} alt="Upload Resume" />
                            <h2>Please Upload Your CV / Resume</h2>
                        </div>
                    </label>
                    {/* <div > */}
                        {errors.resume && <div className="error">{errors.resume[0]}</div>}
                    {/* </div> */}
                    {resumeName && <p className="file-name">📄 {resumeName}</p>} {/* Show file name after upload */}
                    
                    <p className='update-resume'>If you are unable to submit your details, please share your updated resume at <b>hr@omkatech.com</b> </p>
                    
                    <div className="button">
                        <button
                            type="submit"
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                        >
                            <span>APPLY NOW</span>
                            <span className='img'>
                                {isHovered ? (
                                    <img src={GradientArrowIcon} alt="gradient-icon" />
                                ) : (
                                    <img src={ArrowIcon} alt="arrow-icon" />
                                )}
                            </span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Popup;
